// extracted by mini-css-extract-plugin
export default {"RepMenu":"repMenu_RepMenu__1X75d","RepMenuLine":"repMenu_RepMenuLine__NRHxi"};